export enum RequestType {
  PAGE_FETCH = 'PAGE_FETCH',
  ACTION = 'ACTION',
}
